export default "__VITE_ASSET__f9b67bac__"